<template>
    <div class="wx-login-bg">
        <div class="wx-login">
             <img @click="wxloginHide" class="login-close" :src="close_img"/>
            <div id="login_container"></div>
        </div>
    </div>
</template>

<script>
import close_img from '@assets/image/icon/close.png'

export default {
    data(){
        return {
            close_img,
        }
    },
    mounted(){
        //微信登录
        this.login()
         window.WxLogin({
            id:"login_container", 
            appid: "wx40d498dbfafed0fd", 
            scope: "snsapi_login", 
            redirect_uri: "http://localhost:8080/",
            state: "STATE#wechat_redirect",
            style: "black",
            href: ""
        });
    },
    methods:{
        wxloginHide(){
            this.$parent.wxloginHide()
        },
        login(){
               
        },
    }
}
</script>
<style lang="scss" scoped>
.wx-login-bg{
    width: 100%;
    height: 100vh;
    top:0;
    position: fixed;
    background: rgba($color: #000000, $alpha: 0.6);
    z-index: 100;
}
.wx-login{
    width: 35rem;
    height: 26.4rem;
    min-height: 475px;
    min-width: 630px;
    background: #fff;
    border-radius: 4px;
    top:50%;
    bottom: 50%;
    right: 50%;
    left: 50%;
    color: $color;
    padding:3rem 6rem 0;
    margin-top:-13.2rem;
    margin-left:-17rem;
    position: relative;
    text-align: center;
}
.login-close{
    position: absolute;
    top:0.5rem;
    right: 0.5rem;
    cursor: pointer;
}
.wx-title{
    font-size: 1.5rem;
    margin-bottom: 3rem;
}
.wx-img{
    width: 12.3rem;
	height: 12.3rem;
	background-color: #f8f8f8;
	border: solid 1px #9a9a9a;
}
.wx-p{
    font-size: 0.8rem;
    color: #9b9b9b;
    line-height: 3.8rem;
}
</style>